// //USA
// // d-vour API
// export const API_URL = 'https://api.d-vour.com/'; //prod
// // export const API_URL = 'https://d-vour-api.herokuapp.com/'; //dev
// // export const API_URL = 'http://localhost:8000/'; //Local

// // Forunpoint API
// // export const URL = 'https://forunt-point-backend.herokuapp.com/v1/api'; //dev
// export const URL = 'https://api.forunpoint.com:3000/v1/api'; //prod

//Pakistan
// d-vour API
// export const API_URL = 'https://api.d-vour.com.pk/'; //prod


export const API_URL = "https://api-pakistan.d-vour.com/"; //prod
//export const API_URL = "https://forunpoint-pk-dev-000da96aacf1.herokuapp.com//"; //dev


// Forunpoint API
//export const URL ="https://forunpoint-pakistan-815595f6cd55.herokuapp.com/v1/api"; //dev
export const URL = "https://api.forunpoint.com.pk:3000/v1/api"; //prod


// Forunpoint API
//export const URL2 ="https://forunpoint-app-ec645e835ee5.herokuapp.com/v1/api"; //dev
//export const URL2 = "https://api.forunpoint.com.pk:3000/v1/api"; //prod
export const URL2 = ""

// export const API_URL = 'http://localhost:8000/'; //Local